import React, { useEffect, useState } from 'react';
import {
    Grid, TextField, Button, Typography, CircularProgress, IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { db, storage } from '../../../firebase/firebase';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const  Editar_Blogs_Dashboard = () => {

    const { id } = useParams(); // el ID del blog desde la URL
    const navigate = useNavigate();

    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [imagen, setImagen] = useState(null);
    const [imagenURL, setImagenURL] = useState('');
    const [secciones, setSecciones] = useState([{ subtitulo: '', parrafo: '' }]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const cargarBlog = async () => {
            const docRef = doc(db, 'blogs', id);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data();
                setTitulo(data.titulo);
                setDescripcion(data.descripcion);
                setImagenURL(data.imagenDestacada);
                setSecciones(data.secciones || []);
            } else {
                alert('El blog no existe');
                navigate('/dashboard/blogs/');
            }
        };

        cargarBlog();
    }, [id, navigate]);

    const handleImageChange = (e) => {
        setImagen(e.target.files[0]);
    };

    const handleAddSection = () => {
        setSecciones([...secciones, { subtitulo: '', parrafo: '' }]);
    };

    const handleRemoveSection = (index) => {
        setSecciones(secciones.filter((_, i) => i !== index));
    };

    const handleSectionChange = (index, campo, valor) => {
        const nuevas = [...secciones];
        nuevas[index][campo] = valor;
        setSecciones(nuevas);
    };

    const subirImagenYObtenerURL = async () => {
        if (!imagen) return imagenURL;
        const nombreArchivo = `${Date.now()}_${imagen.name}`;
        const imagenRef = ref(storage, `blogs/${nombreArchivo}`);
        await uploadBytes(imagenRef, imagen);
        return await getDownloadURL(imagenRef);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const urlImagen = await subirImagenYObtenerURL();
            await updateDoc(doc(db, 'blogs', id), {
                titulo,
                descripcion,
                imagenDestacada: urlImagen,
                secciones,
            });

            alert('Blog actualizado correctamente');
            navigate('/dashboard/blogs/');
        } catch (error) {
            console.error('Error al actualizar blog:', error);
            alert('Hubo un error');
        } finally {
            setLoading(false);
        }
    };


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 6}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{maxWidth: 1400, px:3, mt:20}}>

                <Grid
                    component="form"
                    onSubmit={handleSubmit}
                    container
                    spacing={2}
                    sx={{ maxWidth: 800 }}
                >
                    <Grid  container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography variant="h5">Editar Blog</Typography>
                    </Grid>

                    <Grid  container size={{xs: 12, sm: 12, md: 12}}>
                        <TextField
                            label="Título del blog"
                            fullWidth
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                        />
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <TextField
                            label="Descripción corta"
                            fullWidth
                            multiline
                            rows={3}
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Button component="label" variant="outlined" fullWidth>
                            Cambiar imagen destacada
                            <input type="file" hidden accept="image/*" onChange={handleImageChange} />
                        </Button>
                        {(imagen?.name || imagenURL) && (
                            <Typography variant="body2" mt={1}>
                                {imagen?.name || 'Imagen actual cargada'}
                            </Typography>
                        )}
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography variant="h6">Secciones del blog</Typography>
                    </Grid>

                    {secciones.map((seccion, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}} key={index}>
                            <TextField
                                label="Subtítulo"
                                fullWidth
                                value={seccion.subtitulo}
                                onChange={(e) =>
                                    handleSectionChange(index, 'subtitulo', e.target.value)
                                }
                            />
                            <TextField
                                label="Párrafo"
                                fullWidth
                                multiline
                                rows={3}
                                value={seccion.parrafo}
                                onChange={(e) =>
                                    handleSectionChange(index, 'parrafo', e.target.value)
                                }
                            />
                            <IconButton onClick={() => handleRemoveSection(index)}>
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    ))}

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Button variant="outlined" onClick={handleAddSection} fullWidth>
                            Agregar sección
                        </Button>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Button type="submit" variant="contained" fullWidth disabled={loading}>
                            {loading ? <CircularProgress size={24} /> : 'Guardar Cambios'}
                        </Button>
                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Editar_Blogs_Dashboard;